// 預設配置值
const defaultApiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.MODE === 'development' ? 'http://localhost:3001' : 'https://api.swag.live');

const defaultIconBaseUrl =
  import.meta.env.VITE_ICON_BASE_URL || 'https://public-ws.swag.live/';

export const config = {
  environment: import.meta.env.MODE || 'development',
  api: {
    baseUrl: defaultApiBaseUrl,
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '10000', 10),
  },
  assets: {
    iconBaseUrl: defaultIconBaseUrl,
    /** 父層是否有傳入 iconBaseUrl（用於判斷是否需要啟用圖片解密） */
    isIconBaseUrlFromParent: false,
    /** 加密金鑰 Map（keyId -> keyValue） */
    encryptKeyMap: new Map<string, string>(),
  },
  debug: {
    enableLogging: import.meta.env.MODE !== 'production',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  },
};

/**
 * 更新域名配置（由父層透過 postMessage 傳入）
 * @param apiUrlPrefix API 前綴 URL
 * @param iconBaseUrl 圖片基礎 URL
 * @param publicUrlEncryptKeys 加密金鑰陣列，格式：['keyId:base64EncodedKey', ...]
 */
export const updateDomainConfig = (
  apiUrlPrefix?: string,
  iconBaseUrl?: string,
  publicUrlEncryptKeys?: string[]
): void => {
  if (apiUrlPrefix && typeof apiUrlPrefix === 'string' && apiUrlPrefix.length > 0) {
    config.api.baseUrl = apiUrlPrefix;
  }
  if (iconBaseUrl && typeof iconBaseUrl === 'string' && iconBaseUrl.length > 0) {
    // 確保結尾有斜線，避免拼接 URL 時出錯
    config.assets.iconBaseUrl = iconBaseUrl.endsWith('/') ? iconBaseUrl : `${iconBaseUrl}/`;
    // 標記父層有傳入 iconBaseUrl（啟用圖片解密）
    config.assets.isIconBaseUrlFromParent = true;
  }
  if (publicUrlEncryptKeys && Array.isArray(publicUrlEncryptKeys)) {
    // 清空並重建 encryptKeyMap
    config.assets.encryptKeyMap.clear();
    publicUrlEncryptKeys.forEach((key) => {
      const [keyId, keyValue] = key.split(':');
      if (keyId && keyValue) {
        config.assets.encryptKeyMap.set(keyId, keyValue);
      }
    });
  }
};

// 調試輔助函數
export const shouldLog = (level: 'debug' | 'info' | 'warn' | 'error' = 'info'): boolean => {
  if (!config.debug.enableLogging) return false;

  const levels = ['debug', 'info', 'warn', 'error'];
  const currentLevelIndex = levels.indexOf(config.debug.logLevel);
  const requestedLevelIndex = levels.indexOf(level);

  return requestedLevelIndex >= currentLevelIndex;
};
